/**
 * Cross-sell inteligente (Product Recommendations API nativa).
 *
 * Progressive enhancement: sem JavaScript a seção simplesmente não
 * aparece (nenhum conteúdo falso). Com JavaScript, busca a própria
 * section renderizada pelo servidor quando se aproxima da viewport.
 * Guard de idempotência no custom element (padrão do projeto).
 */
(function () {
  'use strict';

  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      var self = this;

      var load = function () {
        fetch(self.dataset.url)
          .then(function (response) {
            return response.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length > 0) {
              self.dataset.loaded = 'true';
              self.innerHTML = fresh.innerHTML;
            }
          })
          .catch(function () {
            /* silêncio: cross-sell é progressivo, nunca bloqueia a página */
          });
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              observer.disconnect();
              load();
            }
          },
          { rootMargin: '400px' }
        );
        observer.observe(this);
      } else {
        load();
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
